import { createGlobalStyle } from 'styled-components';

import AllerBoldTtf from '../fonts/Aller/Aller-Bold.ttf';
import AllerRegularTtf from '../fonts/Aller/Aller-Regular.ttf';
import Baloo2RegularTtf from '../fonts/Baloo2/Baloo2-Regular.ttf';
import Baloo2SemiBoldTtf from '../fonts/Baloo2/Baloo2-SemiBold.ttf';
import DagnyProRegularOtf from '../fonts/DagnyPro/DagnyPro.otf';
import Din2014Otf from '../fonts/DIN-2014/DIN-2014-Light.otf';
import DagnyProBoldOtf from '../fonts/DagnyPro/DagnyPro-Bold.otf';
import GibsonLightTtf from '../fonts/Gibson/Gibson-Light.ttf';
import GibsonSemiBoldTtf from '../fonts/Gibson/Gibson-SemiBold.ttf';
import GothamBoldTtf from '../fonts/Gotham/Gotham-Bold.ttf';
import GothamBookTtf from '../fonts/Gotham/Gotham-Book.ttf';
import HelveticaNeueBoldTtf from '../fonts/HelveticaNeue/HelveticaNeue-Bold.ttf';
import HelveticaNeueTtf from '../fonts/HelveticaNeue/HelveticaNeue.ttf';
import InterSemiBoldTtf from '../fonts/Inter/Inter-SemiBold.ttf';
import InterRegularTtf from '../fonts/Inter/Inter-Regular.ttf';
import IsidoraSansRegularOtf from '../fonts/IsidoraSans/IsidoraSans-Regular.otf';
import IsidoraSansRegularTtf from '../fonts/IsidoraSans/IsidoraSans-Regular.ttf';
import IsidoraSansMediumOtf from '../fonts/IsidoraSans/IsidoraSans-Medium.otf';
import IsidoraSansMediumTtf from '../fonts/IsidoraSans/IsidoraSans-Medium.ttf';
import IsidoraSansSemiBoldOtf from '../fonts/IsidoraSans/IsidoraSans-SemiBold.otf';
import IsidoraSansSemiBoldTtf from '../fonts/IsidoraSans/IsidoraSans-SemiBold.ttf';
import LatoRegularTtf from '../fonts/Lato/Lato-Regular.ttf';
import LatoSemiBoldTtf from '../fonts/Lato/Lato-Semibold.ttf';
import MeriweatherBoldTtf from '../fonts/Meriweather/Merriweather-Bold.ttf';
import MeriweatherSansBoldTtf from '../fonts/MerriweatherSans/MerriweatherSans-Bold.ttf';
import MeriweatherSansRegularTtf from '../fonts/MerriweatherSans/MerriweatherSans-Regular.ttf';
import MontserratRegularTtf from '../fonts/Montserrat/Montserrat-Regular.ttf';
import MonterratSemiBoldTtf from '../fonts/Montserrat/Montserrat-SemiBold.ttf';
import NunitoRegularTtf from '../fonts/Nunito/Nunito-Regular.ttf';
import NunitoSemiBoldTtf from '../fonts/Nunito/Nunito-SemiBold.ttf';
import OmnesRegularOtf from '../fonts/Omnes/Omnes-Regular.otf';
import PatuaOneRegularOtf from '../fonts/PatuaOne/PatuaOne-Regular.ttf';
import PublicSansBoldTtf from '../fonts/PublicSans/PublicSans-Bold.ttf';
import PublicSansRegularTtf from '../fonts/PublicSans/PublicSans-Regular.ttf';
import PublicSansSemiBoldTtf from '../fonts/PublicSans/PublicSans-SemiBold.ttf';
import RobotoBoldTtf from '../fonts/Roboto/Roboto-Bold.ttf';
import RobotRegularTtf from '../fonts/Roboto/Roboto-Regular.ttf';
import TitilliumWebLightTtf from '../fonts/TitilliumWeb/TitilliumWeb-Light.ttf';
import TitilliumWebRegularTtf from '../fonts/TitilliumWeb/TitilliumWeb-Regular.ttf';
import TitilliumWebSemiBoldTtf from '../fonts/TitilliumWeb/TitilliumWeb-SemiBold.ttf';

export default createGlobalStyle`

    @font-face {
      font-family: 'Aller';
      src: local('Aller'),
        url(${AllerBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Aller';
      src: local('Aller'),
        url(${AllerRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Baloo2';
      src: local('Baloo2-Regular'),
        url(${Baloo2RegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Baloo2';
      src: local('Baloo2-SemiBold'),
        url(${Baloo2SemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'DagnyPro';
      src: local('DagnyPro'),
        url(${DagnyProRegularOtf}) format('truetype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'DagnyPro';
      src: local('DagnyPro-Bold'),
        url(${DagnyProBoldOtf}) format('truetype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Din2014';
      src: local('Din2014'),
        url(${Din2014Otf}) format('truetype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Gibson';
      src: local('Gibson'),
        url(${GibsonLightTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Gibson';
      src: local('Gibson'),
        url(${GibsonSemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Gotham';
      src: local('Gotham'),
        url(${GothamBookTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Gotham';
      src: local('Gotham'),
        url(${GothamBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'HelveticaNeue';
      src: local('HelveticaNeue'),
        url(${HelveticaNeueTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'HelveticaNeue';
      src: local('HelveticaNeue'),
        url(${HelveticaNeueBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Inter';
      src: local('Inter'),
        url(${InterRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Inter';
      src: local('Inter'),
        url(${InterSemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
        font-family: 'IsidoraSans';
        src: local('IsidoraSans-Regular'),
        url(${IsidoraSansRegularOtf}) format('truetype'),
        url(${IsidoraSansRegularTtf}) format('opentype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
      font-family: 'IsidoraSans';
      src: local('IsidoraSans-Medium'),
        url(${IsidoraSansMediumOtf}) format('truetype'),
        url(${IsidoraSansMediumTtf}) format('opentype');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'IsidoraSans';
      src: local('IsidoraSans-SemiBold'),
        url(${IsidoraSansSemiBoldOtf}) format('truetype'),
        url(${IsidoraSansSemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Lato';
      src: local('Lato'),
        url(${LatoRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Lato';
      src: local('Lato'),
        url(${LatoSemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Meriweather';
      src: local('Meriweather'),
        url(${MeriweatherBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'MeriweatherSans';
      src: local('MeriweatherSans'),
        url(${MeriweatherSansRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'MeriweatherSans';
      src: local('MeriweatherSans'),
        url(${MeriweatherSansBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Montserrat';
      src: local('Montserrat'),
        url(${MontserratRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
    
    @font-face {
      font-family: 'Montserrat';
      src: local('Montserrat'),
        url(${MonterratSemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Nunito';
      src: local('Nunito'),
        url(${NunitoRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Nunito';
      src: local('Nunito'),
        url(${NunitoSemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Omnes';
      src: local('Omnes'),
        url(${OmnesRegularOtf}) format('truetype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'PatuaOne';
      src: local('PatuaOne'),
        url(${PatuaOneRegularOtf}) format('truetype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'PublicSans';
      src: local('PublicSans'),
        url(${PublicSansRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'PublicSans';
      src: local('PublicSans'),
        url(${PublicSansSemiBoldTtf}) format('opentype');
      font-weight: 500;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'PublicSans';
      src: local('PublicSans'),
        url(${PublicSansBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Roboto';
      src: local('Roboto'),
        url(${RobotRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Roboto';
      src: local('Roboto'),
        url(${RobotoBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'TitilliumWeb';
      src: local('TitilliumWeb'),
        url(${TitilliumWebRegularTtf}) format('opentype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'TitilliumWeb';
      src: local('TitilliumWeb'),
        url(${TitilliumWebLightTtf}) format('opentype');
      font-weight: 100;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'TitilliumWeb';
      src: local('TitilliumWeb'),
        url(${TitilliumWebSemiBoldTtf}) format('opentype');
      font-weight: bold;
      font-style: normal;
      font-display: swap;
    }
`;
